import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subject, throwError } from 'rxjs';
import { Company } from 'src/app/core/models/company';
import { AuthenticationService, MODAL_DATA } from '@stockaid/services';
import { CompanyService } from 'src/app/core/services/company.service';
import { MARKET_PLACE_IDS } from '../../../../../core/constants/asc.constant';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  COMMON_FORMAT_DATE,
  FORMAT_PATTERN,
} from 'src/app/core/constants/format-date.constant';
import { ShipStationService } from 'src/app/core/services/v2/ship-station.service';
import { ShipStationApiErrors } from 'src/app/routes/onboarding/create/create.constant';
import { SnotifyService } from 'ng-snotify';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-update-keys-ship-station-modal',
  templateUrl: './update-keys-ship-station-modal.component.html',
  styleUrls: ['./update-keys-ship-station-modal.component.scss'],
})
export class UpdateKeysShipStationModalComponent implements OnInit, OnDestroy {
  companyForm: FormGroup;
  loading: boolean;
  message: string;
  marketplaceIds = MARKET_PLACE_IDS;
  ascInitialDateRange: any = {};
  private unsubscribe: Subject<boolean> = new Subject<boolean>();
  readonly FORMAT_PATTERN = FORMAT_PATTERN;
  readonly FORMAT_DATE = COMMON_FORMAT_DATE;

  constructor(
    @Inject(MODAL_DATA) public data: any,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private companyService: CompanyService,
    private shipStationService: ShipStationService,
    private authService: AuthenticationService,
    private snotifyService: SnotifyService
  ) {
    this.companyForm = this.fb.group({});
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  ngOnInit(): void {
    const min = new Date();
    min.setFullYear(new Date().getFullYear() - 4);
    this.ascInitialDateRange = {
      min,
      max: new Date(),
    };

    this.buildCompanyForm(this.data.company);
  }

  get companyName(): FormControl {
    return this.companyForm.get('companyName') as FormControl;
  }

  get companyApiKey(): FormControl {
    return this.companyForm.get('companyApiKey') as FormControl;
  }

  get currentCompany(): Company {
    return this.companyService.currentCompany();
  }

  private buildCompanyForm(company?: Company) {
    this.message = '';
    this.companyForm = this.fb.group({
      companyName: [''],
      companyApiKey: [''],
    });

    this.companyForm.setControl(
      'companyName',
      this.fb.control(company?.companyName || '', Validators.required)
    );

    this.companyForm.setControl(
      'companyApiKey',
      this.fb.control('', Validators.required)
    );
  }

  updateCredentials(): void {
    if (this.companyForm.invalid || this.loading) {
      return;
    }

    const companyId = this.currentCompany.companyKey;

    const companyApiKey = this.companyApiKey.value;

    this.loading = true;

    // Re-authorize for new companies
    this.shipStationService
      .connect({
        userId: this.authService.currentUser.userId,
        companyId,
        companyApiKey,
      })
      .pipe(
        catchError((err) => {
          switch (err.error) {
            case ShipStationApiErrors.INVALID_API_KEY:
              this.companyApiKey.setErrors({ apiKeyInvalid: true });
              break;
            case ShipStationApiErrors.API_KEY_MISSING:
              this.companyApiKey.setErrors({ apiKeyMissing: true });
              break;
            case ShipStationApiErrors.API_KEY_TAKEN:
              this.companyApiKey.setErrors({ apiKeyTaken: true})
              break;
          }
          return throwError(err);
        })
      )
      .subscribe(
        () => {
          this.activeModal.dismiss();
          this.loading = false;
          this.snotifyService.success(`API key connected successfully`);
        },
        () => {
          this.snotifyService.error(`API key connect failed.`);
          this.loading = false;
        }
      );
  }
}
